import { render } from "./LogoHeader.vue?vue&type=template&id=8375861c"
import script from "./LogoHeader.vue?vue&type=script&lang=js"
export * from "./LogoHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__